export default "__VITE_ASSET__DY_6O$bx__"